exports.menus = [
  [
    { text: "Enrollment/Grades", to: "enrollments", permission: "index_users" },
    {
      text: "Student Information",
      to: "studentInformation",
      permission: "index_users",
    },
    {
      text: "Academic Procedures",
      to: "academicProcedures",
      permission: "index_users",
    },
  ],
  [
    { text: "Google Classroom", href: "https://classroom.google.com" },
    { text: "BSE Mail", href: "https://mail.google.com" },
  ],
];

exports.enrollmentDetailIsElectiveOptions = [
  { value: 1, text: "Yes" },
  { value: 2, text: "No" },
];

exports.outOfProgramOptions = [
  { value: 1, text: "Yes" },
  { value: 2, text: "No" },
];
